@import 'styles/mixins';
@import 'styles/variables';

.header {
  display: flex;
  align-items: center;
  padding: 24px;
  @include xxl-semibold;
  color: $grey-90;
}

.body {
  margin: 0 24px;
  @include lg-regular;
  color: $grey-90;
}

.footer {
  display: flex;
  justify-content: space-between;
  padding: 24px 16px 16px 16px;
}
